/** Hilfsklasse zum bereinigen der Storages, bei versions anpassungen */

import { env } from "../../../environments/environment";
import { CoreCOMService } from "../services/com.service";
import { EnvDir } from "../services/com/comEnvironmentFileSystem";
import { LocalKeys, StorageHive } from "../services/valueStorage.service";
import { ContentType, GetContentDirFromType, YourAPPProductType } from "./contentTypes";

/** StorageCleaner dient für die bereinigung der Speicher, wenn es eine neue version gibt */
export class StorageCleaner {

  /** privater constructor da die classe static ist */
  private constructor() {
  }

  /** serialize object or array to string
   * @param obj Object or array for serialization
   * @returns Serialized object or array
   */
  public static async Update(coreCOMService: CoreCOMService): Promise<void> {
    // Absicherung dass Daten von unterschiedlichen Systemen nicht vermischt werden
    let currentHypCusNr = await coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.storeHypCusNr);
    if (typeof (currentHypCusNr) === "undefined") {
      // erster start, datenbank ist leer, merken reicht
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeHypCusNr, env.HypCusNumber);
    } else if (currentHypCusNr != env.HypCusNumber) {
      // Daten des anderen systems müssen gelöscht werden
      console.error("AppInitialize StorageUpdate System Cleanup", currentHypCusNr, env.HypCusNumber);
      if (coreCOMService.environment.client.isMobile) {
        await coreCOMService.environment.fileSystem.removeAllFiles(EnvDir.Data, "store");
      } else {
        await coreCOMService.environment.indexedDB.clear();
      }
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeHypCusNr, env.HypCusNumber);
    }

    // initilize base data
    let currentVersion = await coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.storeVersion);
    if (typeof (currentVersion) === "undefined") {
      // wenn es keine storeVersion gibt, so kann es aber Daten der 1. Version der YourAPP geben
      // prüfen auf YourAppAuthData, diese ist immer in der 1. Version der YourAPP vorhanden
      const yourAppAuthData = await coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.yourAppAuthData);
      if (typeof (yourAppAuthData) === "undefined") {
        // StoreVersion und YourAppAuthData nicht vorhanden > Speicher ist bereits leer
        currentVersion = env.storeVersion; // gleich auf die aktuelle Version setzen
        await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
      } else {
        currentVersion = 0; // starte mit 0 (bei 1. Version der YourAPP)
      }
    }

    // start update
    let nextVersion = 1; // version 1
    if (currentVersion < nextVersion) {
      // Erweiterung auf Webshop 2.0 hat viele Datenstruckturen verändert 

      const localKeyValues = [
        LocalKeys.yourAppUserData,
        LocalKeys.BonuspointsDataModel,
        LocalKeys.WebshopBasket,
        LocalKeys.WebshopBasketTime,
        LocalKeys.WebshopLastOrderInfo
      ];
      for (const localKey of localKeyValues) {
        await coreCOMService.environment.valueStorage.remove(StorageHive.Local, localKey);
      }

      // product details
      if (coreCOMService.environment.client.isMobile) {
        await coreCOMService.environment.fileSystem.removeDirectory(EnvDir.Data, "store/" + GetContentDirFromType(ContentType.sub_Product));
      } else {
        await coreCOMService.environment.indexedDB.deleteStartWith(GetContentDirFromType(ContentType.sub_Product))
      }

      const contentTypeValues = [
        ContentType.sub_Product,
        ContentType.Item_Group,
        ContentType.Location,
        ContentType.Menu,
        ContentType.MenuSettings,
        ContentType.WebshopSettings,
        ContentType.ArticleAvailabililty,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 2
    if (currentVersion < nextVersion) {
      const localKeyValues = [
        LocalKeys.WebshopBasket,
        LocalKeys.WebshopBasketTime,
        LocalKeys.WebshopLastOrderInfo
      ];
      for (const localKey of localKeyValues) {
        await coreCOMService.environment.valueStorage.remove(StorageHive.Local, localKey);
      }

      const contentTypeValues = [
        ContentType.WebshopSettings,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 3
    // productdetilas3 extend by extra.product_id and extra.rez_id (delete cached productdetails)
    // porduct3 extend by saleable (delete cached products)
    if (currentVersion < nextVersion) {
      // product details
      if (coreCOMService.environment.client.isMobile) {
        await coreCOMService.environment.fileSystem.removeDirectory(EnvDir.Data, "store/" + GetContentDirFromType(ContentType.sub_Product));
      } else {
        await coreCOMService.environment.indexedDB.deleteStartWith(GetContentDirFromType(ContentType.sub_Product));
      }

      const product_key_part = GetContentDirFromType(ContentType.sub_Product);
      if (coreCOMService.environment.client.isMobile) {
        // remove productlist like "product_99999_X.json"
        await coreCOMService.environment.fileSystem.removeFilesByFilter(EnvDir.Data, "store", /^(product_)\d{5}(_)\w(.json)$/);
      } else {
        const fromKey = product_key_part + "_00000_"; // min HypCusNr = 00000
        const toKey = product_key_part + "_99999_"; // max HypCusNr = 99999
        await coreCOMService.environment.indexedDB.deleteRange(fromKey, toKey);
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 4
    if (currentVersion < nextVersion) {
      const localKeyValues = [
        LocalKeys.WebshopBasket,
        LocalKeys.WebshopBasketTime,
        LocalKeys.WebshopLastOrderInfo
      ];
      for (const localKey of localKeyValues) {
        await coreCOMService.environment.valueStorage.remove(StorageHive.Local, localKey);
      }

      const contentTypeValues = [
        ContentType.WebshopSettings,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 5
    // UserInfo3 extend by tag_liked_ids and tag_disliked_ids (delete cached UserInfo3)
    // WebshopSettings2 extend by is_itemtag_enabled and itemtag_type (delete cached products)
    // BonusactionBenefit expendet by last_image_upload_at (delete cached benefits) [cames with bonus branch]
    // porduct4 extend by tag_ids (delete cached products)
    if (currentVersion < nextVersion) {
      const localKeyValues = [
        LocalKeys.yourAppUserData
      ];
      for (const localKey of localKeyValues) {
        await coreCOMService.environment.valueStorage.remove(StorageHive.Local, localKey);
      }

      const contentTypeValues = [
        ContentType.WebshopSettings,
        ContentType.BonusactionBenefit,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      const product_key_part = GetContentDirFromType(ContentType.sub_Product);
      if (coreCOMService.environment.client.isMobile) {
        // remove productlist like "product_99999_X.json"
        await coreCOMService.environment.fileSystem.removeFilesByFilter(EnvDir.Data, "store", /^(product_)\d{5}(_)\w(.json)$/);
      } else {
        const fromKey = product_key_part + "_00000_"; // min HypCusNr = 00000
        const toKey = product_key_part + "_99999_"; // max HypCusNr = 99999
        await coreCOMService.environment.indexedDB.deleteRange(fromKey, toKey);
      }
      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 6
    // Bonusaction extended by description_en (delete cached bonusactions);
    if (currentVersion < nextVersion) {
      const contentTypeValues = [
        ContentType.Bonusaction,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }
      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 7
    // porducts in mobile because the previos versions hat an problem they used /^(product_)\d{5}(_)\w(.json)$/g with g on the end it deletet only a half of files
    if (currentVersion < nextVersion) {
      if (coreCOMService.environment.client.isMobile) {
        // remove productlist like "product_99999_X.json"
        await coreCOMService.environment.fileSystem.removeFilesByFilter(EnvDir.Data, "store", /^(product_)\d{5}(_)\w(.json)$/);
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 8
    if (currentVersion < nextVersion) {
      // Webshopsettings extended
      // Remove all current Baskets and Webshopsettings
      const localKeyValues = [
        LocalKeys.WebshopBasket,
        LocalKeys.WebshopBasketTime,
        LocalKeys.WebshopLastOrderInfo
      ];
      for (const localKey of localKeyValues) {
        await coreCOMService.environment.valueStorage.remove(StorageHive.Local, localKey);
      }

      const contentTypeValues = [
        ContentType.WebshopSettings,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 9
    if (currentVersion < nextVersion) {
      // Ordertypes was added to Webshopsettings
      // Remove all current Baskets and Webshopsettings
      const localKeyValues = [
        LocalKeys.WebshopBasket,
        LocalKeys.WebshopBasketTime,
        LocalKeys.WebshopLastOrderInfo
      ];
      for (const localKey of localKeyValues) {
        await coreCOMService.environment.valueStorage.remove(StorageHive.Local, localKey);
      }

      const contentTypeValues = [
        ContentType.WebshopSettings,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 10
    if (currentVersion < nextVersion) {
      // RecipeLinking wurden als OrderHistory gespeichert
      // Remove all current OrderHistory
      const contentTypeValues = [
        ContentType.OrderHistory,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 11
    if (currentVersion < nextVersion) {
      // Coupons can destroy basket
      // remove basket
      /* es wurde bereits bei betroffenem Kunden ausgeführt, wird nicht mehr benötigt
      coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.WebshopBasket);
      coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.WebshopBasketTime);
      */

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 12
    // productdetilas3 extend by extra.extratext_id (delete cached productdetails)
    if (currentVersion < nextVersion) {
      // product details
      if (coreCOMService.environment.client.isMobile) {
        await coreCOMService.environment.fileSystem.removeDirectory(EnvDir.Data, "store/" + GetContentDirFromType(ContentType.sub_Product));
      } else {
        await coreCOMService.environment.indexedDB.deleteStartWith(GetContentDirFromType(ContentType.sub_Product));
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 13
    // productdetilas3 extend by extra.extratext_id (delete cached productdetails)
    if (currentVersion < nextVersion) {
      // product details
      if (coreCOMService.environment.client.isMobile) {
        await coreCOMService.environment.fileSystem.removeDirectory(EnvDir.Data, "store/" + GetContentDirFromType(ContentType.sub_Product));
      } else {
        await coreCOMService.environment.indexedDB.deleteStartWith(GetContentDirFromType(ContentType.sub_Product));
      }

      // Remove all current SOTItemGroups and SOTSettings (new structure)
      if (env.producttype === YourAPPProductType.sot) {
        const contentTypeValues = [ContentType.SOTItemGroup, ContentType.SOTSettings];
        for (const contentType of contentTypeValues) {
          const key_part = GetContentDirFromType(contentType);
          const fromKey = key_part + "_";
          const toKey = key_part + "_" + "~"; // tilde ist eines der letzten Zeichen in der ASCII Tabelle 
          await coreCOMService.environment.indexedDB.deleteRange(fromKey, toKey);
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 14
    if (currentVersion < nextVersion) {
      // WebshopSettingsDataModel2 wurde erweitert um adyen_allowed_payment_types und Ordertype.PayAtWaiter
      // Lösche WebshopSettings
      const contentTypeValues = [
        ContentType.WebshopSettings,
      ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 15
    if (currentVersion < nextVersion) {
      const contentTypeValues = [ContentType.WebshopSettings, ContentType.Location];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    ++nextVersion; // version 16
    if (currentVersion < nextVersion) {
      // Ordertype.PayAtWaiterExcludedLocations neu, gecachte WebshopSettings löschen
      const contentTypeValues = [ContentType.WebshopSettings];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }

    /* example for update
    ++nextVersion; // version 17
    if (currentVersion < nextVersion) {
      const localKeyValues = [ todo ];
      for (const localKey of localKeyValues) {
        await coreCOMService.environment.valueStorage.remove(StorageHive.Local, localKey);
      }

      if (coreCOMService.environment.client.isMobile) {
        await coreCOMService.environment.fileSystem.removeDirectory(EnvDir.Data, "store/" + (contentdir or dir));
      } else {
        await coreCOMService.environment.indexedDB.deleteStartWith((contentdir or dir))
      }

      const contentTypeValues = [ todo ];
      if (coreCOMService.environment.client.isMobile) {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "store", GetContentDirFromType(contentType) + ".json");       
        }
      } else {
        for (const contentType of contentTypeValues) {
          await coreCOMService.environment.indexedDB.delete(GetContentDirFromType(contentType));
        }
      }

      if (coreCOMService.environment.client.isMobile) {
        await coreCOMService.environment.fileSystem.removeFile(EnvDir.Data, "images/" + contentDir, imageKey); // Image
      } else {
        // Image (store in browser cache)
      }

      currentVersion = nextVersion;
      await coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.storeVersion, currentVersion);
    }
    */

    // check, is planed version 
    if (currentVersion != env.storeVersion) {
      throw new Error(`The storage version ${currentVersion} is not ${env.storeVersion}.`);
    }
    return;
  }

  /** hilfsfunktion zum bereinigen der SOT Daten, z.B. wenn eine andere location eingerichtet wird um alte daten zu bereinigen */
  public static async CleanUpDataOfSOT(coreCOMService: CoreCOMService, location: number): Promise<void> {
    if (env.producttype !== YourAPPProductType.sot) {
      throw new Error("The producttype is not SOT.");
    } else if (coreCOMService.environment.client.isMobile) {
      throw new Error("The SOT is not running on mobile device.");
    } else {
      const contentTypeValues = [
        ContentType.sub_Product, // Artikel werden mit der YourAPP geteilt
        ContentType.RecipeLinking, // Rezepturverkettungen werden mit der YourAPP geteilt
        ContentType.SOTAdvertisement,
        ContentType.SOTItemGroup,
        ContentType.SOTLanguages,
        //ContentType.SOTLogoImage, Images are not stored
        //ContentType.SOTPaymentImage, Images are not stored
        ContentType.SOTRecommendationRules,
        ContentType.SOTSettings,
        ContentType.SOTStartpage,
        ContentType.SOTStyle,
      ];
      for (const contentType of contentTypeValues) {
        const key_part = GetContentDirFromType(contentType);
        const fromKey = key_part + "_" + location;
        const toKey = key_part + "_" + location + "~"; // tilde ist eines der letzten Zeichen in der ASCII Tabelle 
        await coreCOMService.environment.indexedDB.deleteRange(fromKey, toKey);
      }
      // alle artikel details löschen, da es nur an einem standort läuft
      await coreCOMService.environment.indexedDB.deleteStartWith(GetContentDirFromType(ContentType.sub_Product));
    }
    return;
  }

}
